import { render, staticRenderFns } from "./PayrollCalendar.vue?vue&type=template&id=8c3c80fa&scoped=true"
import script from "./PayrollCalendar.vue?vue&type=script&lang=ts"
export * from "./PayrollCalendar.vue?vue&type=script&lang=ts"
import style0 from "./PayrollCalendar.vue?vue&type=style&index=0&id=8c3c80fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3c80fa",
  null
  
)

export default component.exports